export function parseToSlug(string: string) {
  return string
    .replace(/[^a-zA-Z0-9 -]/g, '') // Remove símbolos, exceto letras, números e espaços
    .trim() // Remove espaços extras no início e fim
    .replace(/\s+/g, '-') // Substitui espaços por '-'
    .toLowerCase() // Transforma em minúsculas
}
